import React, { Component } from "react";
import { Card, CardBody, Col, Row, CardTitle, Alert,Container,Button,Table,Badge,CardFooter,Modal } from "reactstrap";
import { AvForm, AvField,AvInput  } from 'availity-reactstrap-validation';
import {CustomPagination} from "../Common/CustomPagination";
import {DataTabeSearch} from '../Common/DataTabeSearch'
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { createParkingSlot,parkingSlotList,editParkingSlot} from '../../../store/parkingSlot/actions';
import { rateTypeList,vehicleTypeList} from '../../../store/parkingRate/actions';
import { parkingSpaceNameList} from '../../../store/parkingSpaceName/actions';

class ParkingSlot extends Component {
    constructor(props) {
        super(props);
        this.state = {
                page: 1,
                per_page: 10,
                search: '',
                customchk: true,
                toggleSwitch: false,
                edittoggleSwitch: false,  
                modal_scroll: false,
                slot: {
                    
                }
            };
        // this.tog_scroll = this.tog_scroll.bind(this);
    }

    componentDidMount()
    {
            this.fetchparkingSlotList();  
            this.fetchRateTypeList();     
            this.fetchVehicleTypeList();     
            this.fetchparkingSpaceNameList();     
    }

    fetchRateTypeList = () => {
        rateTypeList().then((response) => {
            this.setState({
                rateTypeList : response.data.rateType, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchVehicleTypeList = () => {
        vehicleTypeList().then((response) => {
            this.setState({
                vehicleTypeList : response.data.vehicleType, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchparkingSpaceNameList = () => {
        parkingSpaceNameList().then((response) => {
            this.setState({
                parkingSpaceNameList :response.data.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchparkingSlotList = () => {
        let options = {
            page: this.state.page,
            per_page: this.state.per_page,
            search: this.state.search
        }
        parkingSlotList(options).then((response) => {
            console.log('p',response);

            this.setState({
                parkingSlotList :response.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    //modal
    tog_scroll = (slot) => {
        this.setState(prevState => ({
          modal_scroll: !prevState.modal_scroll,
        }));
        this.state.slot = slot;
        this.removeBodyCss();
      }

      removeBodyCss() {
        document.body.classList.add("no_padding");
      }

      // handleValidSubmit
        handleValidSubmit(event, values) {          
            this.props.createParkingSlot(values);

            this.form && this.form.reset();
            this.fetchparkingSlotList(); 
        }

       
       handleEditSubmit(event, values) {  
            this.props.editParkingSlot(values);
            this.setState(prevState => ({
                modal_scroll: !prevState.modal_scroll,
              }));
            // alert('Updated Successfully');
            // window.location.reload();    

            this.fetchparkingSlotList(); 
       }

       handleInputChange = (e) => {
        this.setState({[e.target.name]: e.target.value},() => {
            this.fetchparkingSlotList();
        });
       }

       handlePageClick = (e, index) => {
            e.preventDefault()
            this.setState({
                page: index
            },() => {
                this.fetchparkingSlotList();
            });
        }

    render() {
        let vehicleTypeList = [];
        let rateTypeList = [];
        let parkingSpaceNameList = [];
        let parkingSlotList = [];
        let paginator;
        if (this.state.hasOwnProperty('parkingSlotList')) {
            parkingSlotList = this.state.parkingSlotList.data;
            paginator = {
                'currentPage':this.state.parkingSlotList.currentPage,
                'pagesCount':this.state.parkingSlotList.pagesCount,
                'total':this.state.parkingSlotList.total,
                'to':this.state.parkingSlotList.to,
                'from':this.state.parkingSlotList.from,
            }
        }

        if (this.state.hasOwnProperty('vehicleTypeList')) { vehicleTypeList = this.state.vehicleTypeList; }
        if (this.state.hasOwnProperty('rateTypeList')) { rateTypeList = this.state.rateTypeList; }
        if (this.state.hasOwnProperty('parkingSpaceNameList')) { parkingSpaceNameList = this.state.parkingSpaceNameList; }

        const {id,parking_slot_name_en,parking_slot_name_bn,f_parking_space_id,f_rate_type_id,f_vehicle_type_id,vehicle_capacity} = this.state.slot;

        const getBadge = (status) => {
            return status == 1 ? 'success' : 'secondary'
          }
          
          const getStatusValue = (status) => {
              return status == 1 ? 'Active' : 'In-active'
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>

                        <Breadcrumbs title="Settings" breadcrumbItem="Parking Slot" />
                        {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                        {this.props.success && this.props.success ? <Alert color="success">{this.props.success}</Alert> : null}
                        <Row>
                        <Col lg="6" md="6">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Parking Slot List</CardTitle>
                                        <div className="table-responsive">
                                        <DataTabeSearch handleInputChange={this.handleInputChange}/>
                                            <Table className="table mb-0">

                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Slot Name</th>
                                                        <th>Rate Type</th>
                                                        <th>Parking Space</th>
                                                        <th>Vehicle Type</th>
                                                        <th>Vehicle Capacity</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {parkingSlotList.map((slot, index) =>
                                                    <tr key={slot.id .toString()}>
                                                        <td scope="row">{index+1}</td>
                                                        <td>{slot.parking_slot_name_en}</td>
                                                        <td>{slot.rate_type == null? slot.f_rate_type_id: slot.rate_type.rate_name_en }</td>
                                                        <td>{slot.parking_space_name == null? slot.f_parking_space_id:slot.parking_space_name.space_name_en}</td>
                                                        <td>{slot.vehicle_type == null? slot.f_vehicle_type_id: slot.vehicle_type.vehicle_type_name_en}</td>
                                                        <td>{slot.vehicle_capacity}</td>
                                                        <td><button type="button"
                                                               className="btn btn-sm btn-primary waves-effect waves-light"
                                                               onClick={() => { this.tog_scroll(slot) }} 
                                                               data-toggle="modal"
                                                             >Edit</button>
                                                            </td>
                                                       </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                    {paginator &&
                                     <CardFooter className="p-6">
                                          <CustomPagination paginator={paginator} handlePageClick={this.handlePageClick} />
                                      </CardFooter>
                                      }
                                </Card>
                                <Modal
                                 isOpen={this.state.modal_scroll}
                                   toggle={this.tog_scroll}
                                   scrollable={true}
                                   >
                                   <div className="modal-header">
                                       <h5 className="modal-title mt-0">{parking_slot_name_en}</h5>
                                       <button
                                       type="button"
                                       onClick={() =>
                                           this.setState({ modal_scroll: false })
                                       }
                                       className="close"
                                       data-dismiss="modal"
                                       aria-label="Close"
                                       >
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                   <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleEditSubmit(e,v) }}>
                                       {this.props.msg && this.props.msg ? (
                                           <Alert color="success">
                                               Slot Updated Successfully!
                                           </Alert>
                                           ) : null}
                                           <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Slot Name"  id="parking_slot_name_en" name="parking_slot_name_en" value={parking_slot_name_en} />
                                                     <AvField name="id" id="id" value={id}  type="hidden"  />
                                                 </div>
                                             
                                             
                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Slot  Name (Bangla)"  type="text" name="parking_slot_name_bn" id="parking_slot_name_bn" value={parking_slot_name_bn} />
                                                 </div>
                                            
                                             
                                                 <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Rate Type" name="f_rate_type_id" id="f_rate_type_id" value={f_rate_type_id}>
                                                            <option defaultValue>Select</option>
                                                            {rateTypeList.map((rtype, index) =>
                                                                <option value={rtype.id}>{rtype.rate_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Parking Space" name="f_parking_space_id" id="f_parking_space_id" value={f_parking_space_id}>
                                                            <option defaultValue>Select</option>
                                                            {parkingSpaceNameList.map((space, index) =>
                                                                <option value={space.id}>{space.space_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Vehicle Type" name="f_vehicle_type_id" id="f_vehicle_type_id" value={f_vehicle_type_id}>
                                                            <option defaultValue>Select</option>
                                                            {vehicleTypeList.map((vehicle, index) =>
                                                                <option value={vehicle.id}>{vehicle.vehicle_type_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="col-md-12">
                                                     <AvField className="form-control" label="Vehicle Capacity"  type="number" name="vehicle_capacity" id="vehicle_capacity" value = {vehicle_capacity} />
                                                 </div>

                                                 
                                           <div className="text-center mt-4">
                                                <button type="button" className="btn btn-light mr-2" onClick={this.tog_scroll}>Close</button>
                                                <button type="submit" className="btn btn-success save-event">Save</button>
                                           </div>
                                   </AvForm>
                                   </div>
                               </Modal>
                            </Col>
                            <Col lg="6" md="6">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Create Parking Slot</CardTitle>
                                        
                                        <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleValidSubmit(e,v) }} ref={c => (this.form = c)}>
                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Slot Name"  id="parking_slot_name_en" name="parking_slot_name_en" />
                                                 </div>
                                             
                                             
                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Slot Name (Bangla)"  type="text" name="parking_slot_name_bn" id="parking_slot_name_bn" />
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Vehicle Capacity"  type="number" name="vehicle_capacity" id="vehicle_capacity" />
                                                 </div>
                                            
                                             
                                                 <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Rate Type" name="f_rate_type_id" id="f_rate_type_id">
                                                            <option defaultValue>Select</option>
                                                            {rateTypeList.map((rtype, index) =>
                                                                <option value={rtype.id}>{rtype.rate_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Parking Space" name="f_parking_space_id" id="f_parking_space_id">
                                                            <option defaultValue>Select</option>
                                                            {parkingSpaceNameList.map((space, index) =>
                                                                <option value={space.id}>{space.space_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                                <div className="form-group col-md-12">
                                                    <AvField type="select"className="custom-select" label="Vehicle Type" name="f_vehicle_type_id" id="f_vehicle_type_id">
                                                            <option defaultValue>Select</option>
                                                            {vehicleTypeList.map((vehicle, index) =>
                                                                <option value={vehicle.id}>{vehicle.vehicle_type_name_en}</option>
                                                            )}
                                                    </AvField>
                                                </div>

                                             <div className=" mt-4">
                                                 <Button type="submit" color="success">Submit</Button>
                                             </div>
                                         </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { msg,error,success } = state.ParkingSlot;
    return { msg,error,success };
}

export default withRouter(connect(mapStatetoProps, { createParkingSlot,editParkingSlot })(ParkingSlot));
